import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import { Fuel } from 'lucide-react';
import tnsLogo from '../../../assets/images/tnslogo.png';

const fuelAmounts = [
  { label: '$20', value: '20.00' },
  { label: '$40', value: '40.00' },
  { label: '$60', value: '60.00' },
  { label: '$80', value: '80.00' },
  { label: '$100', value: '100.00' },
  { label: 'Fill Up', value: '150.00', highlight: true },
];

const OPTSelectFuel = ({ onSelectAmount, onCancel }) => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header Bar */}
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-4 h-4 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-base">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1.5">
        <span className="text-xs text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-5" />
      </div>
    </div>

    {/* Main Content */}
    <div className="flex-1 flex flex-col items-center justify-center px-4">
      {/* Fuel pump icon */}
      <Fuel className="w-10 h-10 text-blue-600 mb-2" />
      <h2 className="text-lg font-bold text-gray-800 text-center mb-1">
        Select <span className="text-blue-600">fuel amount</span>
      </h2>
      <p className="text-[10px] text-gray-500 text-center mb-4">
        Choose a preset amount or Fill Up
      </p>

      {/* Fuel Amount Grid */}
      <div className="grid grid-cols-3 gap-2 w-full">
        {fuelAmounts.map((fuel) => (
          <button
            key={fuel.label}
            onClick={() => onSelectAmount(fuel.value)}
            className={`${fuel.highlight 
              ? 'bg-green-600 hover:bg-green-700' 
              : 'bg-blue-600 hover:bg-blue-700'
            } text-white font-bold text-sm rounded-lg py-4 transition-colors`}
          >
            {fuel.label}
          </button>
        ))}
      </div>

      {/* Back */}
      <button
        onClick={onCancel}
        className="mt-4 text-xs text-gray-400 hover:text-gray-600 transition-colors"
      >
        ← Back
      </button>
    </div>
  </div>
);

export default OPTSelectFuel;
